/* SPECIFIC JS FOR THE VIEW IF NEEDED */
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
exports['default'] = b4s3_home;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _domClasslist = require('dom-classlist');

var _domClasslist2 = _interopRequireDefault(_domClasslist);

var _pubsub = require('pubsub');

var _pubsub2 = _interopRequireDefault(_pubsub);

function b4s3_home() {
    var _rub = document.querySelector('.b4s3_home');

    function addListeners() {
        _pubsub2['default'].on('resize', resize);
    }

    function resize(winW, winH) {
        console.log('HOME resize > script/wiews/b4s3_home.js');
    }

    (function init() {
        addListeners();
    })();
}

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9iYWJlL1dvcmsvdjIuZG91YmxlZy51bHRyYW5vaXIuY29tL2Fzc2V0cy9zY3JpcHRzL3ZpZXdzL2I0czNfaG9tZS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7cUJBSXdCLFNBQVM7Ozs7NEJBSFgsZUFBZTs7OztzQkFDbEIsUUFBUTs7OztBQUVaLFNBQVMsU0FBUyxHQUFJO0FBQ2pDLFFBQU0sSUFBSSxHQUFHLFFBQVEsQ0FBQyxhQUFhLENBQUMsWUFBWSxDQUFDLENBQUE7O0FBRWpELGFBQVMsWUFBWSxHQUFFO0FBQ25CLDRCQUFPLEVBQUUsQ0FBQyxRQUFRLEVBQUUsTUFBTSxDQUFDLENBQUM7S0FDL0I7O0FBRUQsYUFBUyxNQUFNLENBQUMsSUFBSSxFQUFFLElBQUksRUFBQztBQUN2QixlQUFPLENBQUMsR0FBRyxDQUFDLHlDQUF5QyxDQUFDLENBQUM7S0FDMUQ7O0FBRUQsS0FBQyxTQUFTLElBQUksR0FBRTtBQUNaLG9CQUFZLEVBQUUsQ0FBQTtLQUNqQixDQUFBLEVBQUcsQ0FBQTtDQUNQIiwiZmlsZSI6Ii9Vc2Vycy9iYWJlL1dvcmsvdjIuZG91YmxlZy51bHRyYW5vaXIuY29tL2Fzc2V0cy9zY3JpcHRzL3ZpZXdzL2I0czNfaG9tZS5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8qIFNQRUNJRklDIEpTIEZPUiBUSEUgVklFVyBJRiBORUVERUQgKi9cbmltcG9ydCBjbGFzc0xpc3QgZnJvbSAnZG9tLWNsYXNzbGlzdCc7XG5pbXBvcnQgcHVic3ViIGZyb20gJ3B1YnN1Yic7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGI0czNfaG9tZSAoKSB7XG4gICAgY29uc3QgX3J1YiA9IGRvY3VtZW50LnF1ZXJ5U2VsZWN0b3IoJy5iNHMzX2hvbWUnKVxuXG4gICAgZnVuY3Rpb24gYWRkTGlzdGVuZXJzKCl7XG4gICAgICAgIHB1YnN1Yi5vbigncmVzaXplJywgcmVzaXplKTtcbiAgICB9XG5cbiAgICBmdW5jdGlvbiByZXNpemUod2luVywgd2luSCl7XG4gICAgICAgIGNvbnNvbGUubG9nKCdIT01FIHJlc2l6ZSA+IHNjcmlwdC93aWV3cy9iNHMzX2hvbWUuanMnKTtcbiAgICB9XG5cbiAgICAoZnVuY3Rpb24gaW5pdCgpe1xuICAgICAgICBhZGRMaXN0ZW5lcnMoKVxuICAgIH0pKClcbn1cbiJdfQ==